function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Immutable from 'seamless-immutable';
import { cloneDeep } from 'lodash';
import uuid from 'uuid/v4';
import { ADD_RATE_SHEET_ITEM, ADD_USAGE_RULE_ITEMS, MODIFIED_USAGE_RULE_ITEMS, RESET_BRI_DATA, RETRIEVE_GUIDANCE_ENTITIES, RETRIEVE_RATE_SHEET, RETRIEVE_USAGE_RULES_FOR_USAGE_RULE_GROUPS, SEARCH_FEES, RETRIEVE_TAX_CODES, SEARCH_PRICING_VECTORS, SEARCH_RATE_SHEET, SET_RATE_SHEET_DETAILS_TAB, SET_NEW_SHEET_ITEM, SET_NEW_USAGE_SHEET_ITEM, SET_PRICING_PLAN_ID, SET_SELECTED_FEE_ID, SET_UBRI_TO_USAGE_RULE_GROUP_MAP, SET_UPDATED_RATE_SHEET_ITEM, UPDATE_FEE, UPDATE_NEW_BRI_ITEMS, UPDATE_SUBSCRIBER_RATE_SHEET, UPDATE_CUSTOMER_RATE_SHEET_USAGE_RULES } from './actions/rate.sheet.actions';
import { BILLER_RULE_INSTANCE_TYPE } from '../customercare.constants';
export var INITIAL_STATE = Immutable({
  addRateSheetItem: null,
  fees: [],
  isRetrievingFees: false,
  feeDetails: {
    selectedFeeId: null,
    glGuidanceCodes: [],
    isRetrievingGuidanceCodes: false,
    isRetrievingTaxCodes: false,
    isUpdatingFee: false,
    taxAssociationCodes: []
  },
  addedUsageRuleItems: [],
  editRateSheetResults: [],
  isRetrievingRateSheet: false,
  isSearchingPricingVectors: false,
  isUpdatingRateSheet: false,
  isUsageRuleGroupLoading: false,
  modifiedUsageRuleItems: [],
  newBriItems: _defineProperty(_defineProperty(_defineProperty({}, BILLER_RULE_INSTANCE_TYPE.ENTITLEMENT, {}), BILLER_RULE_INSTANCE_TYPE.RECURRING, {}), BILLER_RULE_INSTANCE_TYPE.ONETIME, {}),
  pricingVectors: null,
  rateSheetDetailsGoToTab: null,
  rateSheetResults: null,
  retrieveRateSheetError: null,
  searchRateSheetValue: null,
  selectedPricingPlanId: null,
  selectedUsageRuleId: null,
  selectedUsageRuleProductId: null,
  ubriToUsageRuleGroupMap: null,
  usageRuleGroupToUsageRuleMap: null,
  usageRulesToUsageRuleIdMap: null
});
export default (function () {
  var _payload$Items;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case ADD_RATE_SHEET_ITEM:
      return state.set('addRateSheetItem', payload);
    case SEARCH_RATE_SHEET:
      return state.set('searchRateSheetValue', payload);
    case RETRIEVE_RATE_SHEET.BEGIN:
      return state.set('isRetrievingRateSheet', true);
    case SET_UPDATED_RATE_SHEET_ITEM:
      return state.set('updatedRateSheetResults', updatedItems(state.updatedRateSheetResults, payload));
    case SET_NEW_SHEET_ITEM:
      return state.setIn(['newBriItems', payload.ItemType], addOrUpdateBriItem(state.newBriItems[payload.ItemType], payload.addItems));
    case UPDATE_NEW_BRI_ITEMS:
      return state.setIn(['newBriItems', payload.ItemType], payload.items);
    case SET_NEW_USAGE_SHEET_ITEM:
      return state.setIn(['newUsageBriItem'], addOrUpdateBriItem(state.newUsageBriItem, payload));
    case RESET_BRI_DATA:
      return state.set(['newBriItems'], INITIAL_STATE.newBriItems).set(['newUsageBriItem'], null).set(['updatedRateSheetResults'], null);
    case RETRIEVE_RATE_SHEET.SUCCESS:
      return state.set('isRetrievingRateSheet', false).set('editRateSheetResults', (_payload$Items = payload.Items) === null || _payload$Items === void 0 ? void 0 : _payload$Items.map(function (item) {
        var clonedItem = Object.assign({}, item, {
          uuid: uuid()
        });
        return clonedItem;
      })).set('hierarchyRootNodeId', payload.HierarchyRootNodeId).set('rateSheetResults', payload.Items || []);
    case RETRIEVE_RATE_SHEET.FAILURE:
      return state.set('isRetrievingRateSheet', false).set('retrieveRateSheetError', {
        code: payload.Code,
        message: payload.translatedMessage,
        severity: payload.Severity
      });
    case UPDATE_SUBSCRIBER_RATE_SHEET.BEGIN:
      return state.set('isUpdatingRateSheet', true);
    case UPDATE_SUBSCRIBER_RATE_SHEET.SUCCESS:
      return state.set('isUpdatingRateSheet', false);
    case UPDATE_SUBSCRIBER_RATE_SHEET.FAILURE:
      return state.set('isUpdatingRateSheet', false);
    case SEARCH_FEES.BEGIN:
      return state.set('isRetrievingFees', true);
    case SEARCH_FEES.SUCCESS:
      return state.set('isRetrievingFees', false).set('fees', payload.Fees || []);
    case SEARCH_FEES.FAILURE:
      return state.set('isRetrievingFees', false);
    case UPDATE_FEE.BEGIN:
      return state.setIn(['feeDetails', 'isUpdatingFee'], true);
    case UPDATE_FEE.SUCCESS:
      return state.setIn(['feeDetails', 'isUpdatingFee'], false);
    case UPDATE_FEE.FAILURE:
      return state.setIn(['feeDetails', 'isUpdatingFee'], false);
    case RETRIEVE_TAX_CODES.BEGIN:
      return state.setIn(['feeDetails', 'isRetrievingTaxCodes'], true);
    case RETRIEVE_TAX_CODES.SUCCESS:
      return state.setIn(['feeDetails', 'taxAssociationCodes'], payload.TaxAssociations || []).setIn(['feeDetails', 'isRetrievingTaxCodes'], false);
    case RETRIEVE_TAX_CODES.FAILURE:
      return state.setIn(['feeDetails', 'isRetrievingTaxCodes'], false);
    case RETRIEVE_GUIDANCE_ENTITIES.BEGIN:
      return state.setIn(['feeDetails', 'isRetrievingGuidanceCodes'], true);
    case RETRIEVE_GUIDANCE_ENTITIES.SUCCESS:
      return state.setIn(['feeDetails', 'glGuidanceCodes'], payload.GLGuidanceEntities || []).setIn(['feeDetails', 'isRetrievingGuidanceCodes'], false);
    case RETRIEVE_GUIDANCE_ENTITIES.FAILURE:
      return state.setIn(['feeDetails', 'isRetrievingGuidanceCodes'], false);
    case SET_PRICING_PLAN_ID:
      return state.set('selectedPricingPlanId', payload);
    case SET_SELECTED_FEE_ID:
      return state.setIn(['feeDetails', 'selectedFeeId'], payload);
    case UPDATE_CUSTOMER_RATE_SHEET_USAGE_RULES:
      return state.set('editRateSheetResults', payload);
    case ADD_USAGE_RULE_ITEMS:
      return state.set('addedUsageRuleItems', payload);
    case MODIFIED_USAGE_RULE_ITEMS:
      return state.set('modifiedUsageRuleItems', payload);
    case SEARCH_PRICING_VECTORS.BEGIN:
      return state.set('isSearchingPricingVectors', true);
    case SEARCH_PRICING_VECTORS.SUCCESS:
      return state.set('isSearchingPricingVectors', false).set('pricingVectors', payload.PricingVectors || []);
    case SEARCH_PRICING_VECTORS.FAILURE:
      return state.set('isSearchingPricingVectors', false);
    case SET_RATE_SHEET_DETAILS_TAB:
      return state.set('rateSheetDetailsGoToTab', payload);
    case SET_UBRI_TO_USAGE_RULE_GROUP_MAP:
      return state.set('ubriToUsageRuleGroupMap', payload);
    case RETRIEVE_USAGE_RULES_FOR_USAGE_RULE_GROUPS.BEGIN:
      return state.set('isUsageRuleGroupLoading', true);
    case RETRIEVE_USAGE_RULES_FOR_USAGE_RULE_GROUPS.SUCCESS:
      return state.set('usageRuleGroupToUsageRuleMap', getUsageRuleGroupToUsageRuleMap(payload.UsageRules || [])).set('usageRulesToUsageRuleIdMap', getusageRulesToUsageRuleIdMap(payload.UsageRules || [])).set('usageRuleAvailableColsById', getColsForUsageRule(payload.UsageRules || [])).set('isUsageRuleGroupLoading', false);
    case RETRIEVE_USAGE_RULES_FOR_USAGE_RULE_GROUPS.FAILURE:
      return state.set('isUsageRuleGroupLoading', false);
    default:
      return state;
  }
});
function addOrUpdateBriItem(stateBriItem, payloadItem) {
  return stateBriItem && Object.keys(stateBriItem).length ? _objectSpread(_objectSpread({}, stateBriItem), payloadItem) : payloadItem;
}
function updatedItems(existingItems, newItems) {
  var result = cloneDeep(existingItems);
  if (result) {
    newItems.forEach(function (newItem) {
      var matchingItem = result.find(function (existingItem) {
        return existingItem.id === newItem.id && existingItem.BillerRuleConfigurationIdentifier.Value === newItem.BillerRuleConfigurationIdentifier.Value;
      });
      if (matchingItem) {
        result = result.map(function (existingItem) {
          return existingItem.id === newItem.id && existingItem.BillerRuleConfigurationIdentifier.Value === newItem.BillerRuleConfigurationIdentifier.Value ? newItem : existingItem;
        });
      } else {
        result.push(newItem);
      }
    });
  } else {
    result = _toConsumableArray(newItems);
  }
  return result;
}
function getUsageRuleGroupToUsageRuleMap(usageRules) {
  var usageRuleGroupsToUsageRulesMap = {};
  usageRules.forEach(function (usageRule) {
    (usageRule.UsageRuleGroupExternalReferences || []).forEach(function (groupExternalRef) {
      if (!usageRuleGroupsToUsageRulesMap[groupExternalRef]) {
        usageRuleGroupsToUsageRulesMap[groupExternalRef] = [usageRule.Id];
      } else {
        usageRuleGroupsToUsageRulesMap[groupExternalRef] = [].concat(_toConsumableArray(usageRuleGroupsToUsageRulesMap[groupExternalRef]), [usageRule.Id]);
      }
    });
  });
  return usageRuleGroupsToUsageRulesMap;
}
function getusageRulesToUsageRuleIdMap(usageRules) {
  var UsageRuleToUsageRuleIdMap = {};
  usageRules.forEach(function (usageRule) {
    UsageRuleToUsageRuleIdMap[usageRule.Id] = usageRule;
  });
  return UsageRuleToUsageRuleIdMap;
}
var getColsForUsageRule = function getColsForUsageRule(payloadUsageRules) {
  var usageRulesCols = {};
  payloadUsageRules.forEach(function (usageRule) {
    usageRulesCols[usageRule.Id] = usageRule.UsageRates.reduce(function (usageColHashMap, usageRate) {
      if (!usageColHashMap[usageRate.TimeBandCode]) {
        usageColHashMap[usageRate.TimeBandCode] = true;
      }
      return usageColHashMap;
    }, {});
  });
  return usageRulesCols;
};